export const NavigationData = [
    { route: '/dashboard', icon: 'dashboard', text: 'dashboard' },
    { route: '/mySurvey', icon: 'assignment', text: 'myOffers' },
    { route: '/campaign', icon: 'campaign', text: '_campaign' },
    { route: '/leaderboard', icon: 'leaderboard', text: 'leaderboard' },
    { route: '/profileQuestions', icon: 'assignment_ind', text: 'profileQuestion' },
    { route: '/profile', icon: 'person', text: 'myAccount' },
    { route: '/myPoints', icon: 'stars', text: 'myPoints' },
    { route: '/myRedeemption', icon: 'redeem', text: 'redeemPoints' },
    { route: '/refer', icon: 'person_add', text: 'Refer' },
    { route: '/userContact', icon: 'help_center', text: 'contactUs' },
    { route: '/userPrivacy', icon: 'security', text: 'privacyPolicy' },
    { route: '/userFaqs', icon: 'help', text: 'FAQues' },
]

export const MenuItems = [
    { name: 'dashboard', icon: 'dashboard', route: '/dashboard' },
    { name: 'myOffers', icon: 'edit_square', route: '/mySurvey' },
    { name: '_campaign', icon: 'campaign', route: '/campaign' },
    { name: 'leaderboard', icon: 'leaderboard', route: '/leaderboard' },
    { name: 'profileQuestion', icon: 'assignment_ind', route: '/profileQuestions' },
    { name: 'myAccount', icon: 'manage_accounts', route: '/profile' },
    { name: 'myPoints', icon: 'stars', route: '/myPoints' },
    { name: 'redeemPoints', icon: 'redeem', route: '/myRedeemption' },
    // { name: 'Inbox', icon: 'chat', route: '/inbox' }, 
    { name: 'Refer', icon: 'person_add', route: '/refer' },
    { name: 'contactUs', icon: 'support_agent', route: '/userContact' },
    { route: '/userPrivacy', icon: 'security', name: 'privacyPolicy' },
    { route: '/userFaqs', icon: 'help', name: 'faqs' },
];